/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';

//
//
//  TODO : wczytywanie modułów do sklepu powinno być automatyczne. Wszystkie pliki w ./modules
//
//
import access from './modules/access.module';
import application from './modules/application.module';
import auth from './modules/auth.module';
import benefit from './modules/benefit.module';
import benefitsHistory from './modules/benefitsHistory.module';
import benefitUse from './modules/benefitUse.module';
import breadcrumbs from './modules/breadcrumbs.module';
import card from './modules/card.module';
import categories from './modules/categories.module';
import client from './modules/client.module';
import collectionPoint from './modules/collectionPoint.module';
import consents from './modules/consents.module';
import containerBenefit from './modules/containerBenefit.module';
import employees from './modules/employees.module';
import entityHistory from './modules/entityHistory.module';
import groups from './modules/groups.module';
import mailTemplates from './modules/mailTemplates.module';
import modalClose from './modules/modalClose.module';
import notification from './modules/notification.module';
import officials from './modules/officials.module';
import pages from './modules/pages.module';
import partners from './modules/partners.module';
import permissions from './modules/permissions.module';
import pointContainers from './modules/pointContainers.module';
import pointHistory from './modules/pointHistory.module';
import profiles from './modules/profiles.module';
import roles from './modules/roles.module';
import settingGroups from './modules/settingGroups.module';
import settings from './modules/settings.module';
import stats from './modules/stats.module';
import system from './modules/system.module';
import terms from './modules/terms.module';

Vue.use(Vuex);
// Create a new store

const store = new Vuex.Store({
  actions: {},
  getters: {},
  mutations: {},
  state: {},
  modules: {
    access,
    application,
    auth,
    benefit,
    benefitsHistory,
    benefitUse,
    breadcrumbs,
    card,
    categories,
    client,
    collectionPoint,
    consents,
    containerBenefit,
    employees,
    entityHistory,
    groups,
    mailTemplates,
    modalClose,
    notification,
    officials,
    pages,
    partners,
    permissions,
    pointContainers,
    pointHistory,
    profiles,
    roles,
    settingGroups,
    settings,
    stats,
    system,
    terms
  }
});

export default store;
